import React, { memo } from 'react';

//styles
import { Container, SelectedFilter, TrailingIcon, ColorCircle, ColorImage } from './styles';
import ChevronDownSmall from '@nykaa/ui-components/Icons/chevron-down-small';

//constants
import { FilterContainerStates } from 'shared/components/AppliedFiltersV2/constants';

interface IFiltersContainer {
  filters: Record<string, string>[];
  maxFilterToShow?: number;
  type: string;
  setIsFiltersExpanded: (state: boolean) => void;
  onFilterRemove: (key: string, id: string) => void;
  showTrailingIcon?: boolean;
}

function AppliedFiltersContainer({
  filters,
  maxFilterToShow,
  type,
  setIsFiltersExpanded,
  onFilterRemove,
  showTrailingIcon,
}: IFiltersContainer) {
  const visibleFiltersLimit = maxFilterToShow || filters.length;
  const isCollapsed = type === FilterContainerStates.COLLAPSED;
  return (
    <Container isCollapsed={isCollapsed}>
      {filters.slice(0, visibleFiltersLimit).map((filter) => {
        return (
          <SelectedFilter
            key={filter.id}
            selected={true}
            label={filter.name}
            size="small"
            dismissible
            onDismiss={() => onFilterRemove(filter.key, filter.id)}
            icon={
              filter.color_code ? (
                <ColorCircle colorCode={filter.color_code} />
              ) : filter.color_image ? (
                <ColorImage src={filter.color_image} />
              ) : null
            }
          />
        );
      })}
      {showTrailingIcon && (
        <TrailingIcon kind="secondary" size="small" onClick={() => setIsFiltersExpanded(true)}>
          <ChevronDownSmall size="20px" />
        </TrailingIcon>
      )}
    </Container>
  );
}

export default memo(AppliedFiltersContainer);
